import { Button, Stack, Typography } from "@mui/material"

// Shared query-state contract: an error state with Retry and a not-found
// state with a way back. Complements LoadingComponent (loading) and
// EmptyStateContainer (empty) so a failed fetch or a bad id never leaves
// a silent spinner or a blank page. Render inside the page frame so the
// surrounding chrome stays mounted.

export function QueryErrorPanel(props: {
  message?: string
  onRetry: () => void
}) {
  return (
    <Stack
      width={1}
      height={1}
      alignItems="center"
      justifyContent="center"
      gap={2}
      p={3}
    >
      <Typography variant="body1_sb">
        {props.message ?? "Something went wrong while loading this page."}
      </Typography>
      <Button variant="outlined" size="small" onClick={props.onRetry}>
        Retry
      </Button>
    </Stack>
  )
}

export function QueryNotFoundPanel(props: {
  title: string
  description?: string
  backLabel: string
  onBack: () => void
}) {
  return (
    <Stack
      width={1}
      height={1}
      alignItems="center"
      justifyContent="center"
      gap={1}
      p={3}
    >
      <Typography variant="body1_sb">{props.title}</Typography>
      {props.description && (
        <Typography variant="body2" color="text.secondary">
          {props.description}
        </Typography>
      )}
      <Button
        variant="outlined"
        size="small"
        onClick={props.onBack}
        sx={{ mt: 1 }}
      >
        {props.backLabel}
      </Button>
    </Stack>
  )
}
